import { render, staticRenderFns } from "./HospitalStatistics.vue?vue&type=template&id=0ffd4de9&"
import script from "./HospitalStatistics.vue?vue&type=script&lang=js&"
export * from "./HospitalStatistics.vue?vue&type=script&lang=js&"
import style0 from "./HospitalStatistics.vue?vue&type=style&index=0&id=0ffd4de9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports